export default "__VITE_ASSET__DnR$xjdR__"